import { useTranslation } from 'react-i18next';
import './StepOne.css';

interface StepOneProps {
    isLoading: boolean;
    hasError: boolean;
    onRetry: () => void;
}

const StepOne = ({ isLoading, hasError, onRetry }: StepOneProps) => {
    const { t } = useTranslation();

    if (hasError) {
        return null;
    }

    if (!isLoading) {
        return null;
    }

    return (
        <div className="content step-one-container">
            <div className="step-one-content">
                <div className="step-one-icon">⏳</div>
                <p className="step-one-message">
                    {t('primotech.step1.message') || 'Please wait while we create your payment session...'}
                </p>
                <div className="step-one-loading-bar">
                    <div className="step-one-loading-bar-inner"></div>
                </div>
            </div>
        </div>
    );
};

export default StepOne;
